// biome-ignore-all lint/a11y/noNoninteractiveTabindex: Informational tooltip triggers must be keyboard focusable.
import type { ReactNode } from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/admin/coaching/coaching-dashboard/shared/tooltip'
import { useCoachingStore } from '../../store'
import { ELO_SHADE_RAMP, eloContext } from '../_lib/elo-band'

// The ELO shade key for the library tables. It lives in the Library card
// header (LG-362 §7) rather than above the table so the header's right-hand
// dead space carries something useful, and so the key is visible for both the
// Browse and Topic tables without being duplicated in each.
export function EloShadeLegend(): ReactNode {
  const { curriculum } = useCoachingStore()
  const context = eloContext(curriculum)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <p
          tabIndex={0}
          className="ml-auto flex flex-wrap items-center gap-x-1 text-[10px] text-(--cd-text-faint)"
        >
          <span>ELO shade:</span>
          {ELO_SHADE_RAMP.map((shade, index) => (
            // Colours repeat across the ramp, so the index is part of the key.
            <span key={`${shade.color}-${index}`}>
              {index > 0 ? <span aria-hidden="true">· </span> : null}
              <span style={{ color: shade.color }}>{shade.label}</span>
            </span>
          ))}
        </p>
      </TooltipTrigger>
      <TooltipContent>
        {context === null
          ? 'Relative ELO shading is unavailable until the client ELO context is complete.'
          : `ELO shading is relative to ${context.subject}'s ${context.rating} rating and optimal band ${context.lower}–${context.upper}.`}
      </TooltipContent>
    </Tooltip>
  )
}
